import { render } from "./NewOffer.vue?vue&type=template&id=5f153c11&scoped=true"
import script from "./NewOffer.vue?vue&type=script&lang=js"
export * from "./NewOffer.vue?vue&type=script&lang=js"

import "./NewOffer.vue?vue&type=style&index=0&id=5f153c11&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f153c11"]])

export default __exports__